import { connect } from "react-redux";

import { setPanelState } from "../../../Engine/ActionCreators/HiddenPanelActionCreators";

import { PlainForm } from "./PlainForm";

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    setPanelState: setPanelState,
};

export const PlainFormContainer = connect(mapStateToProps, mapDispatchToProps)(PlainForm);
